module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-4-56f9faa9fec1c4cea85de0099962d9a2.jpg";